(function () {
  document.addEventListener('submit', async function (event) {
    const form = event.target.closest('[data-catalog-add-form]');
    if (!form) return;

    event.preventDefault();

    const button = form.querySelector('[data-catalog-add]');
    const label = button && button.querySelector('[data-catalog-add-label]');
    if (!button || button.disabled) return;

    button.disabled = true;
    button.setAttribute('aria-busy', 'true');
    if (label) label.textContent = button.dataset.loadingLabel;

    try {
      const response = await fetch(window.__toytopiaRoutes?.cartAdd || '/cart/add.js', {
        method: 'POST',
        headers: { Accept: 'application/json' },
        body: new FormData(form),
      });

      if (!response.ok) throw new Error('Unable to add product to cart');

      if (label) label.textContent = button.dataset.addedLabel;
      document.dispatchEvent(new CustomEvent('cart:refresh', { detail: { openDrawer: true } }));

      window.setTimeout(function () {
        if (label) label.textContent = button.dataset.defaultLabel;
        button.disabled = false;
        button.removeAttribute('aria-busy');
      }, 1200);
    } catch (error) {
      if (label) label.textContent = button.dataset.defaultLabel;
      button.disabled = false;
      button.removeAttribute('aria-busy');
      HTMLFormElement.prototype.submit.call(form);
    }
  });
})();
